import { Navigate } from 'react-router-dom';

import { useIsAdmin } from '~modules/auth/model';
import { routerKeys } from '~shared/router';

export function AdminIndexPage() {
	const isAdmin = useIsAdmin();

	if (!isAdmin) return <Navigate to={routerKeys.cabinet.root()} />;
	return <Navigate to={routerKeys.cabinet.admin.sections.root()} />;
}
